import { components as c } from "@/components";
import AuthWrap from "@/features/auth/components/AuthWrap";
import { createFileRoute } from "@tanstack/react-router";
import ForgotPasswordForm from "../../features/auth/components/ForgotPasswordForm";

const ForgotPassword = () => {
	const { email } = Route.useSearch();
	return (
		<AuthWrap>
			<c.cc.Title words="Forgot Password" />
			<ForgotPasswordForm email={email} />
		</AuthWrap>
	);
};

export const Route = createFileRoute("/_auth/forgot-password")({
	component: ForgotPassword,
});
